<!-- contacts list  -->
@if (contactList.length > 0 && !isContactSelected) {
  <datalist id="contact-list">
    @for (contact of contactList; track contact) {
      <option (click)="selectContact(contact)" [value]="contact.id">
        {{contact.firstName}} {{contact.lastName}}
      </option>
    }
  </datalist>
}
<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
  <div class="card">
    <div class="card-header">
      <button class="btn btn-light collapse-toggle btn-sm" data-toggle="collapse"
        data-target="#reference-content-collapse" aria-expanded="true"
        aria-controls="reference-content-collapse">
        <span class="collapse-icon"></span>
      </button>
      {{ words[language][ 'references' ] }}
      <button (click)="reset()" title="Add" type="button" class="btn btn-sm btn-primary float-right"
      data-toggle="modal" data-target="#references" [disabled]="contactId == 0">Add</button>
    </div>
    <div class="collapse show" id="reference-content-collapse">
      <div class="card-body">
        @if (relationshipList.length>0) {
          <table class="table table-sm table-hover table-striped table-responsive">
            <thead>
              <tr>
                @for (header of headers; track header) {
                  <th>{{ words[language][ header.name ] }}
                  </th>
                }
              </tr>
            </thead>
            <tbody class="text-dark">
              @for (relationship of relationshipList; track relationship) {
                <tr class="text-dark">
                  <td>{{relationship.firstName}}</td>
                  <td>{{relationship.lastName}}</td>
                  <td>{{relationship.relationship}}</td>
                  <td>{{relationship.started | date:'shortDate'}}</td>
                  <td>{{relationship.ended | date:'shortDate'}}</td>
                  <td>{{relationship.duration}}</td>
                  <td>{{relationship.phone}}</td>
                  <td>{{relationship.comms}}</td>
                  <!-- actions -->
                  <td class="table-action">
                    <button href="javascript: void(0);" class="btn btn-sm btn-outline-dark text-dark"
                      title="More Actions..." data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">Edit</button>
                    <div class="dropdown-menu">
                      <div class="dropdown-item">
                        <button data-toggle="modal" data-target="#updateModalRelationships"
                          class="btn btn-sm btn-outline-dark text-dark" title="Edit"
                        (click)="setRelationship(relationship, 'modify')">Edit Relationship</button>
                      </div>
                      <div class="dropdown-item">
                        <button class="btn btn-sm btn-outline-dark text-dark"
                          (click)="getContactRelationshipDetail(relationship,true)"
                        id="contactReferenceDetail">Edit Contact</button>
                      </div>
                    </div>
                    <button data-toggle="modal" title="Delete" data-target="#DeleteModalRelationships"
                      (click)="setRelationship(relationship, 'delete')"
                    class="btn btn-sm btn-outline-danger text-danger ml-1">Delete</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </div>
  </div>
</div>

<!-- modals -->
<div id="references" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="standard-modalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'addNewReference' ] }}</h4>
        <button type="button" class="close" data-dismiss="modal">×</button>
      </div>
      <div class="modal-body">
        <!-- body -->
        <form [formGroup]="form" class="row">

          <!-- First Name input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="firstName">{{ words[language][ 'firstName' ] }}</label>

            <div class="position-relative hover-list">
              <input class="form-control" type="search" id="firstName" formControlName="firstName"
                autocomplete="off" list="contact-list" autofocus="true" [readonly]="isContactSelected">
            </div>
            @if (firstName.invalid && firstName.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidFirstName' ] }}</span>
            }
          </div>
          <!-- Last Name input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="lastName">{{ words[language][ 'lastName' ] }} </label>
            <input class="form-control" type="text" id="lastName" formControlName="lastName" [readonly]="isContactSelected">
            @if (lastName.invalid && lastName.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidLastName' ] }}</span>
            }
          </div>
          <!-- Relation select-->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="relationship">{{ words[language][ 'relationship' ] }} </label>
            <select class="custom-select custom-select-sm mb-1" id="relationship" formControlName="relationship">
              @for (relationshipType of relationshipTypes; track relationshipType) {
                <option [value]="relationshipType.relation">
                  {{relationshipType.relation | titlecase}}
                </option>
              }
            </select>
          </div>
          <!-- start Date input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="start">{{ words[language][ 'startDate' ] }}</label>
            <input class="form-control" type="date" id="start" formControlName="startDate">
            @if (start.invalid && start.dirty) {
              <span class="text-danger">
                {{ words[language][ 'invalidStartDate' ] }}
              </span>
            }
          </div>
          <!-- End Date input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="end">{{ words[language][ 'endDate' ] }}</label>
            <input class="form-control" type="date" id="end" formControlName="endDate">
            @if (end.invalid && end.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidEndDate' ] }}</span>
            }
          </div>
          <!-- Phone Number input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="phoneNumber">{{ words[language][ 'phoneNumber' ] }}</label>
            <input class="form-control" type="tel" id="phoneNumber" formControlName="phoneNumber">
            @if (phoneNumber.invalid && phoneNumber.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidPhoneNumber' ] }}</span>
            }
          </div>
          <!-- Email Address input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="emailAddress">{{ words[language][ 'emailAddress' ] }}</label>
            <input class="form-control" type="text" id="emailAddress" formControlName="emailAddress">
            @if (emailAddress.invalid && emailAddress.dirty) {
              <span class="text-danger">{{
              words[language][ 'invalidEmailAddress' ] }}</span>
            }
          </div>
        </form>
        <div class="modal-footer">
          <!-- <div class="col-md-12 d-flex justify-content-end px-3 mt-2"> -->
          <!-- add button -->
          <button class="btn btn-success mr-2" id="btn-save-add-references-new" (click)="createContact(false)"
            [disabled]="form.invalid || loading">
            @if (loading) {
              <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
            }
          {{ words[language][ 'add' ] }}</button>
          <!-- save button -->
          <button class="btn btn-success mr-2" id="btn-save-contact-reference" (click)="createContact(true)"
            [disabled]="form.invalid || loading">
            @if (loading) {
              <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
            }
          Save</button>
          <!-- <button class="btn btn-success mr-2" id="btn-save-references-new" (click)="save(true)"
          [disabled]="form.invalid || loading">
          <span class="spinner-grow spinner-grow-sm mr-1" role="status" *ngIf="loading"></span>
        {{ words[language][ 'save' ] }}</button> -->
        <!-- cancel button -->
        <button class="btn btn-light" data-dismiss="modal" id="btn-cancel-references-new">{{
        words[language][ 'cancel' ] }}</button>
      <!-- </div> -->
    </div>
  </div>
</div><!-- /.modal-content -->
</div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- ! delete modal -->
<div class="modal fade" id="DeleteModalRelationships" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="uil-trash-alt text-danger h1"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'deleteReference' ] }}</span>

        <button class="btn btn-danger mt-2" (click)="discard()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
          {{ words[language][ 'continue' ] }}
        </button>
        <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal"
        id="close-delete-modal-reference">{{ words[language][ 'cancel' ] }}</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- todo: update modalmodals -->
<div id="updateModalRelationships" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="standard-modalLabel">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h4 class="modal-title " id="standard-modalLabel">{{ words[language][ 'updateReference' ] }}</h4>
        <button type="button" class="close" data-dismiss="modal">×</button>
      </div>
      <div class="modal-body">
        <!-- body -->
        <form [formGroup]="form" class="row">
          <!-- First Name input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="firstName">{{ words[language][ 'firstName' ] }}</label>
            <input class="form-control" type="search" id="firstName" formControlName="firstName"
              autocomplete="off" list="contact-list">
            @if (firstName.invalid && firstName.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidFirstName' ] }}</span>
            }

          </div>
          <!-- Last Name input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="lastName">{{ words[language][ 'lastName' ] }}</label>
            <input class="form-control" type="text" id="lastName" formControlName="lastName"
              autocomplete="off">
            @if (lastName.invalid && lastName.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidLastName' ] }}</span>
            }
          </div>
          <!-- Relation select-->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="relationship">{{ words[language][ 'relationship' ] }} </label>
            <select class="custom-select mb-1 text-capitalize" id="relationship" formControlName="relationship">
              @for (relationshipType of relationshipTypes; track relationshipType) {
                <option [value]="relationshipType.relation" class="text-capitalize">
                {{relationshipType.relation}}</option>
              }
            </select>
          </div>
          <!-- start Date input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="start">{{ words[language][ 'startDate' ] }}</label>
            <input class="form-control" type="date" max="3000-12-31" id="start" formControlName="startDate">
            @if (start.invalid && start.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidStartDate' ] }}</span>
            }
            <!-- >>>>>>> feature/contact-cleanup -->
          </div>
          <!-- End Date input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="end">{{ words[language][ 'endDate' ] }}</label>
            <input class="form-control" type="date" max="3000-12-31" id="end" formControlName="endDate">
            @if (end.invalid && end.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidEndDate' ] }}</span>
            }
            <!-- >>>>>>> feature/contact-cleanup -->
          </div>
          <!-- Phone Number input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="phoneNumber">{{ words[language][ 'phoneNumber' ] }}</label>
            <input class="form-control" type="tel" id="phoneNumber" formControlName="phoneNumber">
            @if (phoneNumber.invalid && phoneNumber.dirty) {
              <span class="text-danger">{{ words[language][
              'invalidPhoneNumber' ] }}</span>
            }
          </div>
          <!-- Email Address input -->
          <div class="form-group col-md-6 col-sm-12 my-1">
            <label for="emailAddress">{{ words[language][ 'emailAddress' ] }}</label>
            <input class="form-control" type="text" id="emailAddress" formControlName="emailAddress">
            @if (emailAddress.invalid && emailAddress.dirty) {
              <span class="text-danger">{{
              words[language][ 'invalidEmailAddress' ] }}</span>
            }
          </div>
        </form>
        <div class="modal-footer">
          <!-- <div class="col-md-12 d-flex justify-content-end px-3 mt-2"> -->
          <!-- save button -->
          <button class="btn btn-success mr-2" id="btn-save-references-update" (click)="update()"
            [disabled]="form.invalid || loading">
            @if (loading) {
              <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
            }
          Update</button>
          <!-- cancel button -->
          <button class="btn btn-light" data-dismiss="modal" id="close-update-modal-reference">{{
          words[language][ 'cancel' ] }}</button>
        <!-- </div> -->
      </div>
    </div>
  </div><!-- /.modal-content -->
</div><!-- /.modal-dialog -->
</div><!-- /.modal -->

@if (viewDetail) {
  <contact-modal [contactId]="auxContact.id" [language]="language" [words]="words" (modified)="modified($event)"></contact-modal>
}